import React from 'react'
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useFirebaseConnect} from 'react-redux-firebase';

import styled from 'styled-components';
import {colors} from '../styles/colors';

import company_logo from '../img/logo.png'
import insta_ico from '../img/insta_logo.png'

import {getFormatedData} from '../functions/getFormatedData';
import {getStringWithUpperFirstChar} from '../functions/getStringWithUpperFirstChar';
import {getRootCategories} from '../functions/getRootCategories';
import {getFormatedTel} from '../functions/getFormatedTel';

const Container = styled.section`
    position: relative;
    background: ${colors.dark_blue};
    margin-top: 10rem;

    .width-limiter {
        max-width: 1920px;
        padding: 3.75rem 6rem;

        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (min-width: 768px) and (max-width: 959.98px) {
            align-items: flex-start;
        }
        @media (min-width: 768px) and (max-width: 1439.98px) {
            padding: 3.75rem 2rem;
        }
        @media (max-width: 767.98px) {
            padding: 4rem 2rem 5rem 2rem;
            flex-direction: column;
        }
    }
    
    .logo {
        min-width: 100px;
        height: 100px;
    
        background: url(${company_logo}) no-repeat 50% 50%;
        background-size: cover;
    
        mix-blend-mode: multiply;
    
        @media (min-width: 768px) and (max-width: 959.98px) {
            min-width: 70px;
            height: 70px;
    
            margin-right: 4rem;
        }
    }

    .links-container {
        display: flex;

        @media (max-width: 767.98px) {
            flex-direction: column;
        }
    }

    .links-column {
        display: flex;
        flex-direction: column;

        :nth-child(2) {
            border-left: 1px solid ${colors.white};
            border-right: 1px solid ${colors.white};
            padding: 0 8rem;
            margin: 0 8rem;
        }

        @media (min-width: 960px) and (max-width: 1439.98px) {
            :nth-child(2) {
                padding: 0 5rem;
                margin: 0 2rem;
            }
        }
        @media (min-width: 768px) and (max-width: 959.98px) {
            :nth-child(2) {
                padding: 0 4rem;
                margin: 0 2rem;
            }
        }
        @media (max-width: 767.98px) {
            padding: 3rem 0;

            :nth-child(1) {
                border-bottom: 1px solid ${colors.white};
                align-items: center;
            }
            :nth-child(2) {
                display: none;
            }
            :nth-child(3) {
                a, .text {
                    font-size: 1.5rem;
                }
            }
        }
    }

    .column-title {
        margin-bottom: 2.5rem;

        :not(:last-child) {
            text-align: center;
        }

        @media (max-width: 767.98px) {
            display: none;
        }
    }

    a,
    .text,
    .column-title {
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 120%;
        letter-spacing: 0.05em;
        color: ${colors.white};

        @media (min-width: 768px) and (max-width: 1439.98px) {
            font-size: 1.5rem;
        }
    }

    a {
        text-decoration: none;

        :not(:last-child) {
            margin-bottom: 1rem;
        }

        :hover {
            color: ${colors.red};
        }

        @media (min-width: 768px) and (max-width: 1439.98px) {
            :not(:last-child) {
                margin-bottom: 2rem;
            }
        }
        @media (max-width: 767.98px) {
            text-align: center;
            :not(:last-child) {
                margin-bottom: 2.5rem;
            }
        }
    }
    .text {
        max-width: 380px;
        margin-bottom: 1rem;

        @media (min-width: 959.98px) and (max-width: 1439.98px) {
            max-width: 289px;
        }
        @media (max-width: 1439.98px) {
            margin-bottom: 2.5rem;
        }
    }

    .insta-ico {
        min-width: 30px;
        height: 30px;

        background: url(${insta_ico}) no-repeat 50% 50%;
        background-size: cover;
        mix-blend-mode: multiply;

        cursor: pointer;

        @media (min-width: 1920px) {
            position: absolute;
            bottom: 10rem;
        }
        @media (min-width: 768px) and (max-width: 1439.98px) {
            position: absolute;
            right: 5rem;
            bottom: 5rem;
        }
    }

    .inc {
        color: ${colors.white};
        font-family: sans-serif;
        font-size: 1rem;
        font-weight: 300;

        position: absolute;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
    }
    
`;


export const Footer = () => {

    const year = new Date().getFullYear()
    useFirebaseConnect(['main_data/'])

    const categories = getFormatedData(useSelector(state => state.firebase.data.products && state.firebase.data.products.categories))
    const root_categories = getRootCategories(categories)
    const main_data = useSelector(state => state.firebase.data.main_data)

    function handleClick() {
        window.scrollTo(0, 0);
    }

    return (
        <Container>

            <div className="width-limiter">
                <Link to='/' onClick={() => handleClick()}>
                    <div className={'logo'}/>
                </Link>

                <div className="links-container">
                    <div className="links-column">
                        <p className='column-title'>Разделы</p>
                        <Link to='/' onClick={() => handleClick()}>Главная</Link>
                        <Link to='/products' onClick={() => handleClick()}>Продукция</Link>
                        <Link to='/service' onClick={() => handleClick()}>Сервисное <br/> обслуживание</Link>
                        <Link to='/contacts' onClick={() => handleClick()}>Контакты</Link>
                    </div>
                    <div className="links-column">
                        <p className='column-title'>Продукция</p>
                        {root_categories && root_categories.length !== 0 ? root_categories.map(category => <Link
                            to={`products/${category.category_name}`} key={category.key}
                            onClick={() => handleClick()}> {getStringWithUpperFirstChar(category.category_name)} </Link>) : null}
                    </div>
                    <div className="links-column">
                        <p className='column-title'>Контакты</p>
                        {main_data ? <>
                            <p className='text'> {main_data.address} </p>
                            <a href={`tel:${getFormatedTel(main_data.tel)}`}> {main_data.tel} </a>
                            <a href={`mailto:${main_data.email}`}> {main_data.email} </a>
                        </> : null}
                    </div>
                </div>

                {main_data ?
                    <a target="_blank" href={`https://www.instagram.com/${main_data.insta}`} rel="noopener noreferrer">
                        <div className="insta-ico"/>
                    </a> : null}
            </div>

            <p className='inc'>©{year}, Флагман </p>

        </Container>
    )
}
